import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { SSlider } from "./Slider.styles";
import { SocketContext } from "../../context/SocketContext";
import RangeSlider from "react-bootstrap-range-slider";
import "react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css";
import { MediaContext } from "../../context/MediaContext";
import SyncDonutGraph from "../Charts/SyncDonutGraph";
import { QuestionModal } from "../Modals/Modals";

export const Slider = () => {
  const { t } = useTranslation("", { keyPrefix: "components.slider" });

  const { sendSocketEvent } = useContext(SocketContext);
  const { getVideoTs } = useContext(MediaContext);
  const [value, setValue] = useState(3);
  const [fuzzy, setFuzzy] = useState(true);
  const [showQuestionModal, setShowQuestionModal] = useState(false);

  const onSliderChange = (e) => {
    setValue(e.target.value);

    sendSocketEvent("feedback/understanding", {
      value: parseInt(e.target.value),
      videoTs: getVideoTs(),
    });
  };
  const onClickAsk = () => {
    setShowQuestionModal(true);
  };

  const variant = value <= 1 ? "danger" : value > 2 ? "success" : "warning";

  return (
    <SSlider onMouseEnter={() => setFuzzy(false)} onMouseLeave={() => setFuzzy(true)}>
      <div className="reaction" onClick={onClickAsk}>
        <i className="fs-1 fas fa-question" />
        <div className="description">{t("ask")}</div>
      </div>
      <div className="d-flex flex-column">
        <span className="title">{t("question1")}</span>
        <div className="d-flex flex-row justify-content-center align-items-center">
          <i className="fas fa-times fa-2x px-1" />
          <RangeSlider
            tooltipLabel={(value) => {
              return value === 1 ? t("not_clear") : value === 2 ? t("half_clear") : t("clear");
            }}
            tooltip="on"
            variant={variant}
            value={value}
            min={1}
            max={3}
            size="lg"
            onChange={onSliderChange}
          />
          <i className="fas fa-check fa-2x px-1" />
        </div>
      </div>
      <div className="h-100 mx-1">
        <SyncDonutGraph legend={false} fuzzy={fuzzy} />
      </div>
      <QuestionModal show={showQuestionModal} onHide={() => setShowQuestionModal(false)} />
    </SSlider>
  );
};
